<template>
  <div class="navBar">
    <div class="navWidth meadia-navWidth">
      <el-dropdown :class="[isActive==i?'menu active':'menu']" v-for="(item,i) in menu" :key='i' placement='bottom'>
        <span class="el-dropdown-link" @click="changeTab(i)">{{ item.ts002 }}</span>
        <el-dropdown-menu slot="dropdown" v-if="item.children && item.children.length>0">
          <el-dropdown-item v-for="(tab,j) in item.children" :key='j' class=''>
            <div class="item" @click="changeTab(i,j)">{{ tab.ts002 }}</div>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
import bus from '../../public/bus.js'

export default {
  data() {
    return {
      menu: [{
        name: '网站首页',
        path: '/',
      },
        {
          name: '政策法规',
          children: [{
            name: '政策法规',
            path: '/active/0',
          },
            {
              name: '物流动态',
              path: '/active/1',
            },
            {
              name: '最新资讯',
              path: '/active/2',
            },]
        },
        {
          name: '新能源监管',
          children: [{
            name: '监管大厅',
            url: ''  //后台首页
          },
            {
              name: '物流企业',
              path: '/enterprise',
            },
            {
              name: '充电桩',
              path: '/charging',
            },
            {
              name: '末端配送站',
              path: '/distribution',
              // 暂无
            },
            {
              name: '物流企业登录',
              path: '/services',
            },
            {
              name: '通行证申请',
              path: '',
              //暂无
            },]
        },
        {
          name: '行业服务',
          children: [{
            name: '应急服务站',
            path: '/industry/0',
          }, {
            name: '诚信建设',
            path: '/industry/1',
          },
            {
              name: '企业联盟',
              path: '/industry/2',
            },
            {
              name: '安全生产',
              path: '/industry/3',
            },]
        },
        {
          name: '车货配载',
          children: [
            {
              name: '车主找货',
              path: '/carFindGood',   //显示最新货源//多一个搜索和发布
              //暂无
            },
            {
              name: '货主找车',
              path: '/goodFindCar',   //多一个搜索 多一个搜索和发布
              //暂无
            }, {
              name: '最新车源',
              path: '/options',
            }, {
              name: '最新货源',
              path: '/supplyOfGoods',
            }]
        },
        {
          name: '关于平台',
          children: [{
            name: '关于平台',
            path: '/about',
          }, {
            name: '意见建议',
            path: '/suggestion',
            //暂无
          },
            {
              name: '投诉',
              path: '/complaints',
              //暂无
            },
          ]
        }
      ],
      isActive: 0,
    };
  },
  created() {
    (async () => {
      let {data} = await this.getMenu();
      let center = data.data.sort((a, b) => {
        return a.ts007 - b.ts007;
      })
      center = center.filter(ele => (ele.ts008 > 0));
      center.forEach(ele => {
        if (ele.children && !!ele.ts008) {
          ele.children =  ele.children.sort((a, b) => {
            return a.ts007 - b.ts007;
          })
          ele.children = ele.children.filter(val => (val.ts008 > 0));
        }
      })
      this.menu = center;
      this.autoTab(this.$swiper)
    })()
    // this.getMenu()
    bus.$on('catchTab', res => {
      this.isActive = res;
    })

  },
  watch: {
    $route(to, from) {
      this.autoTab(to.path);
    }
  },
  methods: {
    getMenu() {
      return this.$axios.post('/api/webMenu/list/web', {
        skip: 0,
        pageSize: 100,
      })
    },
    changeTab(index, child = 999) {
      let nowRouter = this.$route.name;
      let menu = this.menu;
      if (menu[index].children.length > 0 && child != 999) {
        console.log("AA00:"+nowRouter);
        // 首页下新打开页面
        if (menu[index].children[child].ts005 == 1) {
          console.log("AAAA:nowRouter="+nowRouter);
          if (nowRouter == 'index') {
            let {href} = this.$router.resolve({path: menu[index].children[child].ts004});
            this.isActive = index;
            console.log("BBBB:tohref="+href);
            window.open(href, '_blank');
          } else {
            this.$router.push({
              path: menu[index].children[child].ts004
            })
          }
        } else {
          let way = '_self';
          if (nowRouter == 'index') {
            way = "_blank";
          }
          window.open(menu[index].children[child].ts004, way);
        }
      } else {
        if (menu[index].ts005 == 1 && menu[index].children.length < 1) {
          if (nowRouter == 'index') {
            let {href} = this.$router.resolve({path: menu[index].ts004});
            this.isActive = index;
            window.open(href, '_blank');
          } else {
            this.isActive = index;
            this.$router.push({
              path: menu[index].ts004
            })
          }

        } else {
          if (menu[index].ts004) {
            let way = '_self';
            if (nowRouter == 'index') {
              way = "_blank";
            }
            window.open(menu[index].ts004, way);
          } else {
            return false;
          }
        }
      }
    },
    autoTab(path) {
      this.menu.forEach((ele, i) => {
        if (ele.children) {
          ele.children.forEach(val => {
            if (val.ts004 == path) {
              this.isActive = i;
            }
          })
        } else if (ele.ts004 == path) {
          this.isActive = i;
        }
      })
    }
  }
}
</script>

<style scoped>
.navBar {
  overflow: hidden;
  width: 100%;
  height: 7rem;
  background: linear-gradient(to bottom, #FFFFFF, #E3E3E3);
}

.navWidth {
  display: flex;
  justify-content: space-between;
  width: 140rem;
  margin: 0 auto;
  cursor: pointer;
}

.menu {
  height: 7rem;
  padding: 0 1rem;
  line-height: 7rem;
  color: #0083CE;
  font-size: 1.8rem;
}

.active {
  background-color: #0083CE !important;
  color: white !important;
}

.item {
  font-size: 1.8rem;
  /* width: 24rem; */
  padding: 1.5rem 2rem 2.2rem;
}

.el-dropdown-link {
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/common/navBar.vue